module.exports = __webpack_public_path__ + "static/media/Welder.d49ac1d3.jpg";